const tags = ['div', 'span', 'ul', 'li', 'label', 'button', 'img', 'a', 'svg', 'p']
const defaultStyle =
  'box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;'
const labelStyle =
  'background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;float:none;outline:none;'
const buttonStyle =
  'background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;border:0;border-radius:0;outline:none;position:static;'
const imgStyle = 'border:0;display:inline-block;vertical-align:top;border-radius:0;outline:none;position:static;'

export default (id: string) => {
  const withPrefix = (data: string) => `#wf_${id} ${data}`

  let css = `${withPrefix('.wf_reset{font-size:14px;}')}\n`
  tags.forEach(tag => {
    css += `${withPrefix(`${tag}.wf_reset{${defaultStyle}}`)}\n`
  })
  css += `${withPrefix('a.wf_reset{border:0;display:inline;}')}\n`
  css += `${withPrefix('p.wf_reset{margin:1.4em 0;}')}\n`
  css += `${withPrefix('span.wf_reset{display:inline;}')}\n`
  css += `${withPrefix(`label.wf_reset{${labelStyle}}`)}\n`
  css += `${withPrefix(`button.wf_reset{${buttonStyle}}`)}\n`
  css += `${withPrefix(`img.wf_reset{${imgStyle}}`)}\n`
  css += `${withPrefix('.wf_reset button::-moz-focus-inner{border: 0;}')}\n`

  css += `${withPrefix('.wf_reset_tree{font-size:14px;}')}\n`
  tags.forEach(tag => {
    css += `${withPrefix(`.wf_reset_tree ${tag}{${defaultStyle}}`)}\n`
  })
  css += `${withPrefix('.wf_reset_tree a{border:0;display:inline;}')}\n`
  css += `${withPrefix('.wf_reset_tree p{margin:1.4em 0;}')}\n`
  css += `${withPrefix('.wf_reset_tree span{display:inline;}')}\n`
  css += `${withPrefix(`.wf_reset_tree label{${labelStyle}}`)}\n`
  css += `${withPrefix(`.wf_reset_tree button{${buttonStyle}}`)}\n`
  css += `${withPrefix(`.wf_reset_tree img{${imgStyle}}`)}\n`
  css += withPrefix('.wf_reset_tree button::-moz-focus-inner{border: 0;}')

  return css
}
